import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/kyuuyo_02.png")